<template>
    <SmuMenuDropdown v-if="languages" v-model="locale" :items="languageKeys">
        <template #value>{{ locale.toUpperCase() }}</template>
        <template #item="{ item }">
            <div class="w-full">
                {{ languages[item] }}
            </div>
        </template>
    </SmuMenuDropdown>
</template>

<script setup lang="ts">
const { t } = useI18n();
const { locale } = storeToRefs(useLocalSettingsStore());
const { data } = storeToRefs(useUserStore());

const fallbackLanguageCodes = [
    "de",
    "en",
    "nl",
    "fr",
    "ar",
    "sv",
    "pl",
    "tr",
    "es",
    "ko",
    "ja",
    "it",
    "cs",
    "da",
    "sk",
    "hu",
];

const languages = computed(() => {
    const langs = data.value?.app.languages;

    if (langs?.length) {
        return Object.fromEntries(
            langs.map((lang) => [
                lang.code,
                lang.name[locale.value] ?? lang.name[lang.code],
            ]),
        );
    }

    return Object.fromEntries(
        fallbackLanguageCodes.map((code) => [
            code,
            t(`helpers.language.${code}`),
        ]),
    );
});

const languageKeys = computed(() => Object.keys(languages.value));
</script>
